<template>
  <AddCourseRoleModal
    v-if="showAddCourseRoleModal"
    :roleId="roleId"
    :courseId="courseIdSelected"
    @closeModal="closedAddRemoveCourseRoleModal"
  />
  <RemoveCourseRoleModal
    v-if="showRemoveCourseRoleModal"
    :roleId="roleId"
    :courseId="courseIdSelected"
    @closeModal="closedAddRemoveCourseRoleModal"
  />
  <LoadingData v-if="loadData" />
  <div v-else class="card">
    <div class="card-header py-0">
      <h6 class="py-3 mb-0">Cursos</h6>
    </div>
    <div class="card-body">
      <h5>Associados ao Cargo</h5>
      <div v-if="coursesRole.length > 0" class="row">
        <div
          v-for="course in coursesRole"
          :key="course.id"
          class="col-lg-3 col-md-4 col-sm-6 mb-3"
        >
          <CardCourse
            :course="course"
            borderColor="success"
            :showStatus="true"
            :showProgress="false"
          >
            <router-link
              :to="`/courses/${course.id}`"
              title="Visualizar detalhes do curso"
            >
              <span class="badge bg-primary">Detalhes do Curso</span>
            </router-link>
            <span
              role="button"
              class="badge bg-danger ms-2"
              title="Remover este curso do cargo"
              @click="removeCourseRole(course.id)"
            >
              Remover Associação
            </span>
          </CardCourse>
        </div>
      </div>
      <p v-else>Nenhum curso está associado a este cargo</p>
      <hr />
      <h5>Não Associados ao Cargo</h5>
      <div v-if="coursesUnrelatedRole.length > 0" class="row">
        <div
          v-for="course in coursesUnrelatedRole"
          :key="course.id"
          class="col-lg-3 col-md-4 col-sm-6 mb-3"
        >
          <CardCourse
            :course="course"
            borderColor="secondary"
            :showStatus="true"
            :showProgress="false"
          >
            <router-link
              :to="`/courses/${course.id}`"
              title="Visualizar detalhes do curso"
            >
              <span class="badge bg-primary">Detalhes do Curso</span>
            </router-link>
            <span
              role="button"
              class="badge bg-success ms-2"
              title="Associar este curso ao cargo"
              @click="addCourseRole(course.id)"
            >
              Associar ao Cargo
            </span>
          </CardCourse>
        </div>
      </div>
      <p v-else>Todos os cursos já estão vinculados a este cargo</p>
    </div>
  </div>
</template>

<script>
import AddCourseRoleModal from '@/components/roles/courses/AddCourseRoleModal.vue'
import RemoveCourseRoleModal from '@/components/roles/courses/RemoveCourseRoleModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import CardCourse from '@/components/commons/CardCourse.vue'

export default {
  name: 'CoursesRole',

  components: {
    AddCourseRoleModal,
    RemoveCourseRoleModal,
    LoadingData,
    CardCourse,
  },

  props: {
    roleId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loadData: true,
      showAddCourseRoleModal: false,
      showRemoveCourseRoleModal: false,
      coursesRole: [],
      coursesUnrelatedRole: [],
      courseIdSelected: null,
    }
  },

  methods: {
    async getCoursesRole() {
      try {
        this.coursesRole = await this.$store.dispatch(
          'getCoursesRole',
          this.roleId,
        )
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getCoursesUnrelatedRole() {
      try {
        this.coursesUnrelatedRole = await this.$store.dispatch(
          'getCoursesUnrelatedRole',
          this.roleId,
        )
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    addCourseRole(courseId) {
      this.courseIdSelected = courseId
      this.showAddCourseRoleModal = true
    },

    removeCourseRole(courseId) {
      this.courseIdSelected = courseId
      this.showRemoveCourseRoleModal = true
    },

    closedAddRemoveCourseRoleModal(loadData) {
      if (loadData) {
        this.getCoursesRole()
        this.getCoursesUnrelatedRole()
      }
      this.showAddCourseRoleModal = false
      this.showRemoveCourseRoleModal = false
    },
  },

  mounted() {
    this.getCoursesRole()
    this.getCoursesUnrelatedRole()
  },
}
</script>
